const DEFAULT_ZENDESK_SUPPORT_URL = 'https://tigergraph.zendesk.com';

/** Base URL for enterprise support; override with VITE_ZENDESK_SUPPORT_URL if needed. */
export function getZendeskSupportBaseUrl(): string {
  return import.meta.env.VITE_ZENDESK_SUPPORT_URL || DEFAULT_ZENDESK_SUPPORT_URL;
}

/**
 * Open Zendesk in a new tab (noopener/noreferrer) after validating the URL.
 * Use for enterprise tier and anywhere the API returns a known HTTPS redirect.
 */
export function openZendeskSupportInNewTab(urlString?: string): boolean {
  try {
    const raw = urlString?.trim() || getZendeskSupportBaseUrl();
    const parsed = new URL(raw, window.location.origin);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return false;
    }
    window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
    return true;
  } catch {
    return false;
  }
}

export function isEnterpriseSupportTier(tier: string | undefined): boolean {
  if (!tier) return false;
  return String(tier).toLowerCase() === 'enterprise';
}
